import { Handle } from '@/core/geometry'

export function isHandle(value: unknown): value is Handle {
  return typeof value === 'string' && Object.values(Handle).some((handle) => handle === value)
}
